export default "__VITE_ASSET__Cao8av$W__"